<div class="select-profile-wrapper">
  <div class="selected-profile tw-flex tw-flex-col">
    <mat-label *ngIf="isLabelVisible" class="fixed-filter-label"
      >{{ 'common.uiKit.monitoring.label.selectedProfile' | translate }}
    </mat-label>
    <div class="tw-flex tw-justify-center tw-items-end">
      <div class="selected-profile__name-wrapper tw-flex">
        <span>{{ name }}</span>
        <span *ngIf="!name && !isLabelVisible" class="selected-profile__name-placeholder">
          {{ 'common.uiKit.monitoring.label.selectProfile' | translate }}
        </span>

        <ui-svg-icon
          *ngIf="id"
          class="selected-profile__close-icon"
          [name]="iconNameList.Close"
          [width]="20"
          (click)="removeProfile.next()"
        ></ui-svg-icon>
      </div>
      <button *ngIf="!id; else updateProfileButtons" class="profile-button" (click)="selectProfile.next()">
        <ui-svg-icon class="selected-profile__add-icon" [name]="iconNameList.Add" [width]="20"></ui-svg-icon>
      </button>
    </div>
  </div>

  <mat-slide-toggle
    *ngIf="id && defaultProfileControl"
    [formControl]="defaultProfileControl"
    class="selected-profile__default-toggle tw-self-center"
    color="primary"
  >
    {{ 'common.field.default' | translate }}
  </mat-slide-toggle>
</div>

<ng-template #updateProfileButtons>
  <button class="profile-button" (click)="selectProfile.next()">
    <ui-svg-icon [name]="iconNameList.Add" [width]="20" class="selected-profile__edit-icon"></ui-svg-icon>
  </button>
  <button
    *ngIf="isUpdateProfileVisible"
    class="profile-button"
    [disabled]="!isUpdateProfileAvailable"
    (click)="updateProfile.next()"
  >
    <ui-svg-icon [name]="iconNameList.Save" [width]="20" class="selected-profile__save-icon"></ui-svg-icon>
  </button>
</ng-template>
